import React, { useEffect, useState } from "react";
import { adminGetAllBlogs, adminDeleteBlog } from "../api/admin";
import BlogTable from "../components/BlogTable";
import BlogForm from "../components/BlogForm";
import "./BlogsPage.css";
import { toast } from "react-toastify";

const BlogsPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [editingBlog, setEditingBlog] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // RBAC check
  const hasWritePermission = () => {
    const role = localStorage.getItem("adminRole");
    if (role === "admin") return true;
    const permissions = JSON.parse(localStorage.getItem("adminPermissions") || "[]");
    return permissions.includes("Blogs:write");
  };
  const canWrite = hasWritePermission();

  const fetchBlogs = async () => {
    try {
      const res = await adminGetAllBlogs();
      const blogList =
        Array.isArray(res?.data) ? res.data :
          Array.isArray(res?.data?.data) ? res.data.data :
            Array.isArray(res?.data?.blogs) ? res.data.blogs :
              [];
      setBlogs(blogList);
    } catch (error) {
      console.error("Blog fetch failed", error);
      setBlogs([]);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  const filteredBlogs = (blogs || []).filter(b => {
    const term = searchTerm.toLowerCase();
    return (
      (b.title || "").toLowerCase().includes(term) ||
      (b.author || "").toLowerCase().includes(term)
    );
  });

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this blog?")) return;
    try {
      await adminDeleteBlog(id);
      fetchBlogs();
      toast.success("Blog deleted successfully! 🗑️");
    } catch (error) {
      console.error("Error deleting blog:", error);
      toast.error(error.response?.data?.message || "Failed to delete blog. ❌");
    }
  };

  const handleEdit = (blog) => {
    setEditingBlog(blog);
    setShowForm(true);
  };

  const clearEdit = () => {
    setEditingBlog(null);
    setShowForm(false);
  };

  return (
    <div className="admin-page">
      {!showForm ? (
        <>
          <div className="page-header">
            <h2 className="adminproducts">Blogs</h2>
            <div className="header-actions">
              <div className="search-container">
                <span className="search-label">Search:</span>
                <input
                  type="text"
                  className="user-search-input"
                  placeholder="Search by article..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="header-controls-row">
                <div className="admin-count-badge">
                  Total Blogs: {blogs.length}
                </div>
                {canWrite && (
                  <button className="btn-add-product" onClick={() => { setEditingBlog(null); setShowForm(true); }}>
                    + Add Blog
                  </button>
                )}
              </div>
            </div>
          </div>

          <BlogTable blogs={filteredBlogs} onDelete={handleDelete} onEdit={handleEdit} canWrite={canWrite} />
        </>
      ) : (
        <>
          <div className="page-header">
            <div className="header-with-back">
              <button className="back-btn" onClick={clearEdit}>← Back</button>
              <h2 className="adminproducts">
                {editingBlog ? "Update Blog" : "Create New Blog"}
              </h2>
            </div>
          </div>
          <div className="form-inline-container">
            <BlogForm
              blog={editingBlog}
              onSuccess={() => {
                fetchBlogs();
                clearEdit();
              }}
              onCancel={clearEdit}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default BlogsPage;

